import React from 'react';
import { openLegal } from './LegalModal';

// ============================================================
// Terms & Privacy links.
//
// One canonical document: Backend/legal/terms-and-privacy.html. The build copies
// it into public/legal (scripts/copy-legal.js), so the app opens it IN-APP
// (LegalModal.tsx — offline too) and portal.investmenter.com/terms and /privacy
// serve it to the outside world. The backend's /terms and /privacy stay up for
// links that were already sent out.
// ============================================================

// Public addresses (App Store / Play Store listings, links opened outside the
// app). portal.investmenter.com serves the copy in public/legal via firebase.json.
export const TERMS_URL = 'https://portal.investmenter.com/terms';
export const PRIVACY_URL = 'https://portal.investmenter.com/privacy';

/** Click handler for a Terms / Privacy link: opens the in-app panel instead of leaving the app. */
export function openPolicy(url: string) {
  return (e: React.MouseEvent) => {
    e.preventDefault();
    openLegal(/privacy/i.test(url) ? 'privacy' : 'terms');
  };
}
